module.exports = __webpack_public_path__ + "img/pay-value10.56b4d938.png";